document.addEventListener("DOMContentLoaded", () => {
    const postStatusBlock = document.querySelector(".wp-block-klingit-basic-post-reading-time");

    if (postStatusBlock && postStatusBlock.querySelector(".post-reading-status")) {
        const specificSection = document.querySelector(".read-time-section");
        const fullReadingTime = parseInt(postStatusBlock.querySelector(".post-reading-time span.time-left").innerHTML);

        const setScrollBar = () => {
            const windowBottom = document.querySelector("body").scrollTop + window.innerHeight;
            const elementTop = specificSection.getBoundingClientRect().top;
            const scrollPercentage = Math.round((windowBottom - elementTop) / specificSection.getBoundingClientRect().height * 100);
            const readingTimePassed = Math.round(fullReadingTime * scrollPercentage / 100);

            postStatusBlock.querySelector(".post-reading-status").style.setProperty('--currentPostPercentage', scrollPercentage + "%");

            let readingTimeLeft = fullReadingTime - readingTimePassed;
            if (readingTimeLeft <= 0) {
                readingTimeLeft = '<1';
            }
            postStatusBlock.querySelector(".post-reading-time span.time-left").innerHTML = readingTimeLeft;
        }

        setScrollBar();

        window.addEventListener("scroll", () => setScrollBar());
    }
});